import { messages as en } from "../i18n/en";
import { type MessageKey, messages as es } from "../i18n/es";
import { useUI } from "../stores/ui";

/**
 * Lightweight translator hook. Returns a `t(key)` function that resolves
 * against the active catalogue with fallback to Spanish.
 */
export function useT(): (key: MessageKey, fallback?: string) => string {
  const locale = useUI((s) => s.locale);
  const catalog = locale === "en" ? en : es;
  return (key, fallback) => catalog[key] ?? fallback ?? es[key] ?? String(key);
}
